import axios from "axios";
import UAParser from "ua-parser-js";
import { API_GET, API_POST, API_PUT } from "../config/axiosConfig";
import { sendEventsLog } from "./UserController";
import { LOG_EVENTS_DEVICE_DATA, LOG_EVENTS_USER_LOGIN_DATA } from "../constants";
import { getDeviceInfo } from "../utils/generalUtils";
import { setToSessionStorage } from "../hooks/useSessionStorage";

export async function createVanityLink(data) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_links`;
        const respAxios = await API_POST(url, data);
        return respAxios;
    } catch (error) {
        console.log("Error creating vanity link:", error);
        return error;
    }
}

export async function createVanityLinkData(data) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_link_data`;
        const respAxios = await API_POST(url, data);
        return respAxios;
    } catch (error) {
        console.log("Error creating vanity link data:", error);
        return error;
    }
}

export async function updateVanityLinkData(id, data) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_link_data/${id}`;
        const respAxios = await API_PUT(url, data);
        return respAxios;
    } catch (error) {
        console.log("Error creating vanity link data:", error);
        return error;
    }
}

export async function updateVanityLink(vanityId, data) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/${vanityId}`;
        const respAxios = await API_PUT(url, data);
        return respAxios;
    } catch (error) {
        console.log("Error creating vanity link data:", error);
        return error;
    }
}

export async function updateVanityLinkDataImages(id, formData, token) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_link_data/${id}`;

        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        };
        const response = await API_PUT(url, formData, config);
        return response;
    } catch (err) {
        return err;
    }
}

export async function createVanityLinkDataWithFiles(formData, token) {
    const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_link_data`;
    try {
        const config = {
            method: "post",
            maxBodyLength: Infinity,
            url,
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        };
        const response = await API_POST(url, formData, config);
        return response;
    } catch (error) {
        console.log("error:", error);
        return error;
    }
}

export async function fetchVanityLinkData(pathId) {
    if (pathId.includes(".html")) {
        console.debug("fetchVanityLinkData: dcv iframe path detected, skipping");
        return null;
    }
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/vanity_link_data/${pathId}`);
        if (response) {
            setToSessionStorage("vanityLinkData", JSON.stringify(response.data));
            return response;
        }
    } catch (error) {
        console.log("Error grabbing vanity link:", error);
        return error;
    }
}

export async function fetchVanityLinkByRoomId(roomId) {
    console.log("fetchVanityLinkByRoomId for roomId:", roomId);
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/room/${roomId}`);

        if (response.status === 200 && response) {
            return response;
        }

        return null;
    } catch (error) {
        console.error("Error grabbing vanity link:", error);
        return error;
    }
}

export async function fetchVanityLinkBySlug(slug) {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/${slug}`);
        if (response?.status === 200 && response) {
            return response;
        }
        return null;
    } catch (error) {
        console.error(`Error fetching vanity link by slug ${slug}:`, error);
        return null;
    }
}

export async function fetchVanityLinkAvatarPresets(vanityLink) {
    try {
        const response = await API_GET(
            `${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/avatar_presets/${vanityLink}`
        );

        return response;
    } catch (error) {
        console.error("Error grabbing Avatar Presets:", error);
        return null;
    }
}

export async function sendAutoLoginLink(email, vanity) {
    try {
        const data = {
            email,
            vanity,
            url: process.env.REACT_APP_WEB_URL,
        };

        const response = await API_POST(
            `${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/autologin`,
            data,
            "",
            "POST"
        );

        if (response.status === 200 && response) {
            return response;
        }

        return null;
    } catch (error) {
        console.error("Error sending auto login:", error);
        return null;
    }
}

export async function authenticateAutoLoginLink(userId, token, vanity) {
    try {
        const data = {
            userId,
            vanity,
        };

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${process.env.REACT_APP_CORE_API_URI}/web/vanity_links/autologin/authenticate`,
            data,
            config
        );
        if (response.status === 200 && response) {
            const deviceInfo = await getDeviceInfo();
            const eventJson = {
                guestLogin: true,
                user: response.user,
                clientName: vanity,
            };
            await sendEventsLog(response.token, vanity, userId, LOG_EVENTS_USER_LOGIN_DATA, "login", eventJson, "", "");
            await sendEventsLog(response.token, vanity, userId, LOG_EVENTS_DEVICE_DATA, "info", deviceInfo, "", "");

            return response;
        }

        return null;
    } catch (error) {
        console.error("Error authenticating auto login:", error);
        return null;
    }
}

export async function fetchAllVanityData() {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/vanity_links`;
        const respAxios = await API_GET(url);
        if (respAxios?.status === 200) {
            return respAxios?.data?.vanityLinks;
        }
        return [];
    } catch (err) {
        console.error("Error fetching data:", err);
        return [];
    }
}

export async function fetchEventDetails(id) {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/clients/events/${id}`);
        if (response.status === 200 && response) {
            return response.data.events;
        }
        if (response && response.status !== 200) {
            return null;
        }
    } catch (error) {
        console.error("Error getting events data:", error);
        return null;
    }
}

export async function submitEventsData(data) {
    try {
        const url = `${process.env.REACT_APP_CORE_API_URI}/web/clients/events/submit`;
        const respAxios = await API_POST(url, data);
        return respAxios;
    } catch (error) {
        console.error("Error grabbing Avatar Presets:", error);
        return error;
    }
}

export async function fetchAllAvatarPresets() {
    try {
        const response = await API_GET(`${process.env.REACT_APP_CORE_API_URI}/web/avatar/avatar-presets`);
        console.log("response", response);
        if (response.status === 200 && response) {
            return response.data.avatars;
        }
        if (response && response.status !== 200) {
            return [];
        }
    } catch (error) {
        console.error("Error getting events data:", error);
        return [];
    }
}
